module.exports = __webpack_public_path__ + "static/media/quality.d8dad4ca.svg";